import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { compose, mapProps, withState, lifecycle } from 'recompose'
import { times, constant, isEmpty } from 'lodash'
import { updateObject } from 'helpers/objectHelpers'
import HoverBar from 'components/hover/HoverBar'
import ConditionDialog from 'components/Dialog/ConditionDialog'
import { updateItemArrayByIndex } from 'helpers/arrayHelpers'
import { Button } from 'semantic-ui-react'
import { withSortableCollection } from 'hocs/bases/withSortableCollection'
import { initialSingleImage } from 'helpers/initialState'
import FormImageElement from './FormImageElement'

const ConditionWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`

const FormMultiImagesWithCustom = compose(
  withState('editCondition', 'isEditCondition', ({ value }) => {
    return times(value.length, constant(false))
  }),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      // re-initial isEditCondition boolean list on add new banner case.
      if (nextProps.value !== this.props.value) {
        this.props.isEditCondition(times(nextProps.value.length, constant(false)))
      }
    },
  }),
  mapProps(({ value, onChange, ...props }) => ({
    collection: value,
    onUpdate: onChange,
    ...props,
  })),
  withSortableCollection({
    dataSet: initialSingleImage,
  }),
)(
  ({
    index,
    item,
    editCondition,
    isEditCondition,
    onReplaceItemByIndex,
    onDeleteByIndex,
    isHorizontal,
  }) => {
    const handleChange = (val) => onReplaceItemByIndex(index, val)
    // add condition as attribute of banner object. 
    const handleConditionChange = (conditions) => {
      const conditionAttribute = { hideIn: {}, showOnlyIn: {} }
      conditions.forEach((val) => {
        // add condition to item data
        switch (val.condition) {
          case 'is':
            conditionAttribute.showOnlyIn[val.name] = val.value.split(',')
            break;
          case 'is_not':
            // tranform string comma to array.
            conditionAttribute.hideIn[val.name] = val.value.split(',')
            break;
          default:
        }
      })
      handleChange(updateObject(item, { ...conditionAttribute }))
      isEditCondition(updateItemArrayByIndex(editCondition, index, (isOpen) => !isOpen))
    }
    // create condition status to show below image banner.
    const getImageConditionDesc = (val) => {
      let conditionStr = ''
      if (!isEmpty(val.hideIn)) conditionStr += 'hide in : '
      Object.entries(val.hideIn).forEach(([key, value]) => {
        // transfrom value from array back to comma sting.
        conditionStr += ` ${key} = ${value.isArray ? value.join() : value} `
      })
      if (!isEmpty(val.showOnlyIn)) conditionStr += ' show only in : '
      Object.entries(val.showOnlyIn).forEach(([key, value]) => {
        conditionStr += ` ${key} = ${value.isArray ? value.join() : value} `
      })
      return conditionStr
    }
    // simplify show/hide attr on banner object to show on dialog.
    const tranformConditionData = (val) => {
      const conditionData = []
      Object.entries(val.hideIn || []).forEach(([key, value]) => {
        conditionData.push({
          name: key,
          condition: 'is_not',
          value: value.toString(),
        })
      })
      Object.entries(val.showOnlyIn || []).forEach(([key, value]) => {
        conditionData.push({
          name: key,
          condition: 'is',
          value: value.toString(),
        })
      })
      return conditionData
    }
    return (
      <div>
        <HoverBar
          icons={[
            { icon: 'fa fa-trash', onClick: () => onDeleteByIndex(index) },
          ]}
        >
          <FormImageElement
            isHorizontal={isHorizontal}
            value={item}
            style={{ marginBottom: 10 }}
            onChange={handleChange}
          >
            <FormImageElement.ActiveSwitch
              value={item.active}
              onChange={(val) => handleChange(updateObject(item, { active: val }))}
            />
            <ConditionWrapper>
              <div>
                <b>Conditon : </b>
                <div>
                  {
                    (item.hideIn && item.showOnlyIn) &&
                    getImageConditionDesc(item)
                  }
                </div>
              </div>
              <Button style={{ marginLeft: '10px' }} icon="edit" onClick={() => { isEditCondition(updateItemArrayByIndex(editCondition, index, (isOpen) => !isOpen)) }} />
            </ConditionWrapper>
          </FormImageElement>
        </HoverBar>
        <ConditionDialog
          title={'Banner condition'}
          open={editCondition[index]}
          onClose={() => isEditCondition(updateItemArrayByIndex(editCondition, index, (isOpen) => !isOpen))}
          condition={tranformConditionData(item)}
          onUpdateCondition={handleConditionChange}
        />
      </div>
    )
  },
)

FormMultiImagesWithCustom.propTypes = {
  isHorizontal: PropTypes.bool,
}
FormMultiImagesWithCustom.defaultProps = {
  isHorizontal: true,
}

export default FormMultiImagesWithCustom



// WEBPACK FOOTER //
// ./src/components/forms/image/FormMultiImagesWithCustom.js